/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, June 30th 2022, 11:02:50 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { AsyncAPIListAutoComplete, OSAvatar } from "ui-widgets";
import { APISERVICEPATHS } from "lib/api";
import { OrganizationListItem } from "lib/schemas";

interface OrganizationDropdownSelectorProps {
  switchOrganization: (selectedOrganization: OrganizationListItem) => void;
  selectedOrganization: OrganizationListItem;
}

export const OrganizationDropdownSelector = ({
  switchOrganization,
  selectedOrganization,
}: OrganizationDropdownSelectorProps) => {
  return (
    <AsyncAPIListAutoComplete<OrganizationListItem>
      id="organization-select-dropdown"
      label="Select Organization"
      itemIdProperty="id"
      getOptionLabel={(option) => option.name}
      loadingText="Loading Organizations"
      onChangeCallBack={switchOrganization}
      value={selectedOrganization ?? ({} as OrganizationListItem)}
      apiServicePath={APISERVICEPATHS.workerOrganizations}
      apiQueryParams={{ active: true }}
      disableClearable
      inputStartAdornment={
        <OSAvatar
          name={selectedOrganization?.name}
          imageSrc={selectedOrganization?.logo}
          variant="rounded"
          sx={{ width: 28, height: 28 }}
        ></OSAvatar>
      }
      tooltipProps={{ placement: "top" }}
    />
  );
};
